module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.eed9aab.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module id = 448
// module chunks = 1